import { NavigationGuard } from "vue-router";
import { userModule } from "@/store/modules/user";
import { correctPemeriksaanRoute } from "@/utils/actingUnit";

const actingUnitGuard: NavigationGuard = (to, from, next) => {
  if (!userModule.isSignedIn) {
    userModule.exitActingUnit();
    return next();
  }

  const fix = correctPemeriksaanRoute(to);
  if (fix) {
    return next(Object.assign({}, fix, { replace: true }));
  }

  userModule.syncActingUnit(to);

  next();
};

export default actingUnitGuard;
